import { mapActions } from "vuex";
export default {
  data: () => ({
    loading: {
      save: false
    },
    messages: {
      403: true,
      404: true,
      400: true
    }
  }),
  methods: {
    preSubmit() {
      return null;
    },
    postSubmit() {
      return null
    },
    getPath() {
      return null;
    },
    getMethod() {
      return 'PUT';
    },
    getMessages() {
      return this.messages
    },
    async save() {
      this.notify({ status: false });

      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.notify({ message: this.$t("errors.400E") });
        return;
      }
      this.preSubmit();
      let error;
      let response;
      try {
        response = await this.request({
          url: this.getPath(),
          data: this.getData(this.form),
          method: this.getMethod(),
          messages: this.getMessages()
        });
        this.$emit("success", response);
      } catch (err) {
        error = err;
        this.$emit("error", err);
      }
      this.postSubmit(response, error);
    },
    getData(form) {
      const data = {};
      for (const prop in form) {
        if (form[prop] === null || typeof form[prop] === "undefined") continue;
        data[prop] = form[prop];
      }
      return data;
    },
    resetForm() {
      return;
    },
    ...mapActions({ request: "request", notify: "notification/notify" })
  }
};
